import { render } from "./SectionByTagPage.vue?vue&type=template&id=713177cc"
import script from "./SectionByTagPage.vue?vue&type=script&lang=js"
export * from "./SectionByTagPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.44_typescript@6.0.3__webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__